import React, { useRef, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { isString, isObject, isNumber } from 'lodash';

//import { Popup } from 'devextreme-react';
//import { SimpleItem, EmptyItem, ButtonItem, ButtonOptions, GroupItem } from 'devextreme-react/form';
//import { RequiredRule } from 'devextreme-react/form';
import { Toast } from 'devextreme-react';

import { useAuth } from '../../contexts/auth';

//import { FormStyled } from './LoginForm.Styled';
import {
    LoginContentStyled,
    LoginPageStyled,
    LoginPageModalBoxStyled,
    LoginPageLogoStyled,
    LoginPageLabelStyled,
    LoginPageInputStyled,
    LoginPageButtonStyled,
} from './LoginForm.Styled';


const formData = {
    // email: 'dalma.vad@gmail.com',
    // password: 'qwe',
    email: __DEVELOPMENT__ ? 'torokze@gmail.com' : '',
    password: __DEVELOPMENT__ ? 'xlcjvo' : '',
    //email: '',
    //password: '',
};


function LoginForm(props) {

    //const formRef = useRef();
    const emailRef = useRef();
    const passRef = useRef();
    //const signInRef = useRef();

    const { login } = useAuth();
    const { t } = useTranslation();


    const [ loginResult, setLoginResult ] = useState({
        show:false,
        message:''
    });


    useEffect(() => {
        if (emailRef.current) {
            emailRef.current.value = formData.email;
            emailRef.current.select();
            emailRef.current.focus();
        }
        if (passRef.current) {
            passRef.current.value = formData.password;
        }
    }, [emailRef.current, passRef.current]);


    const onSignInClick = useCallback(() => {
        setLoginResult(old => ({ ...old, show:false }));

        //const emailValidity = emailRef.current.validity.valid || false;
        //const passValidity = passRef.current.validity.valid || false;

        if ((formData.email || '').trim().length === 0) {
            setLoginResult({
                show:true,
                message:'** Invalid or missing email address.'
            });
            return;
        }
        if ((formData.password || '').trim().length === 0) {
            setLoginResult({
                show:true,
                message:'** Enter your password.'
            });
            return;
        }

        //if (!formRef.current.instance.validate().isValid)
        //    return;

        login(formData.email, formData.password, props.builder)
            .then(() => {
                formData.password = '';
            })
            .catch(response => {
                if (isString(response))
                    setLoginResult({
                        show:true,
                        message:`* ${t('Error')}: ${t(response)}`
                    });
                else if (isObject(response) && (response.status || 200) !== 200) {
                    setLoginResult({
                        show:true,
                        message:`* ${t('Error')}: ${t(response.data.msg)}`
                    });
                }
                else if (isNumber(response)) {
                    setLoginResult({
                        show:true,
                        message:`* ${t('Error')}: ${t('You have no right to use builder tool')}`
                    });
                }
                else {
                    setLoginResult({
                        show:true,
                        message:`* ${t('Error')}: ${t('Network error')}`
                    });
                }
            })
        ;
    }, [formData.email, formData.password, setLoginResult]);


    const onLoginResultToastHidden = useCallback(() => {
        setLoginResult(old => ({ ...old, show:false }));
    }, []);


    const isPureEnter = (keyEvent) => {
        try {
            if (keyEvent.key === "Enter" &&
                !keyEvent.altKey &&
                !keyEvent.ctrlKey &&
                !keyEvent.shiftKey)
                return true;
        }
        catch(ex) {
        }
        return false;
    };


    return (
        <>
            <LoginContentStyled className={'content-block'}>
                {/*<editor-fold>*/}
                {/*<h1>{props.builder ? t("PanoWeb Manager") : t("PanoWeb Viewer")}</h1>*/}
                {/*<h3>{document.location.origin}</h3>*/}
{/*                <Popup*/}
{/*                    animation={null}*/}
{/*                    focusStateEnabled={true}*/}
{/*                    closeOnOutsideClick={false}*/}
{/*                    dragEnabled={false}*/}
{/*                    height={'auto'}*/}
{/*                    width={'512px'}*/}
{/*                    minWidth={'512px'}*/}
{/*                    position={{*/}
{/*                        my:'center',*/}
{/*                        at:'center',*/}
{/*                        of:'window'*/}
{/*                    }}*/}
{/*                    showCloseButton={false}*/}
{/*                    showTitle={true}*/}
{/*                    shading*/}
{/*                    shadingColor={'rgba(0,0,0,0.5)'}*/}
{/*                    title={t('Login')}*/}
{/*                    visible={false}*/}
{/*                >*/}
{/*                    <FormStyled*/}
{/*                        ref={formRef}*/}
{/*                        formData={formData}*/}
{/*                        activeStateEnabled={true}*/}
{/*                        focusStateEnabled={true}*/}
{/*                        alignItemLabels={true}*/}
{/*                        alignItemLabelsInAllGroups={true}*/}
{/*                        onEditorEnterKey={onSignInClick}*/}
{/*                    >*/}
{/*                        <GroupItem*/}
{/*                            colCount={1}*/}
{/*                            alignItemLabels={true}*/}
{/*                        >*/}
{/*                            <SimpleItem*/}
{/*                                dataField={'email'}*/}
{/*                                editorType={'dxTextBox'}*/}
{/*                                editorOptions={{*/}
{/*                                    mode:'email',*/}
{/*                                    valueChangeEvent:'keyup'*/}
{/*                                }}*/}
{/*                                label={{*/}
{/*                                    text:'E-mail',*/}
{/*                                    alignment:'right'*/}
{/*                                }}*/}
{/*                            >*/}
{/*                                <RequiredRule message={t("Email name is required")} />*/}
{/*                            </SimpleItem>*/}
{/*                            <SimpleItem*/}
{/*                                dataField={'password'}*/}
{/*                                editorType={'dxTextBox'}*/}
{/*                                editorOptions={{*/}
{/*                                    mode:'password',*/}
{/*                                    valueChangeEvent:'keyup'*/}
{/*                                }}*/}
{/*                                label={{*/}
{/*                                    text:t('Password'),*/}
{/*                                    alignment:'right'*/}
{/*                                }}*/}
{/*                            >*/}
{/*                                <RequiredRule message={t("Enter your password")} />*/}
{/*                            </SimpleItem>*/}
{/*                        </GroupItem>*/}
{/*                        <EmptyItem />*/}
{/*                        <GroupItem>*/}
{/*                            <ButtonItem*/}
{/*                                horizontalAlignment={'center'}*/}
{/*                                buttonOptions={{*/}
{/*                                text:t("Sign in"),*/}
{/*                                useSubmitBehavior:false,*/}
{/*                                onClick:onSignInClick,*/}
{/*//                                width:160*/}
{/*                            }}/>*/}
{/*                        </GroupItem>*/}
{/*                    </FormStyled>*/}
{/*                </Popup>*/}
                {/*</editor-fold>*/}
                <LoginPageStyled>
                    <LoginPageModalBoxStyled>
                        { __VISUELSE__ && <LoginPageLogoStyled src="images/site-viewer-logo.png"/> }
                        <LoginPageLabelStyled>Email:*</LoginPageLabelStyled>
                        <LoginPageInputStyled
                            ref={emailRef}
                            autoComplete="off"
                            type="email"
                            spellCheck="false"
                            required={true}
                            onKeyDown={(e) => { try { if (isPureEnter(e)) passRef.current.focus(); } catch(ex) {} } }
                            onKeyUp={(e) => { try { formData.email = e.target.value } catch(ex) {} } }
                        />
                        <LoginPageLabelStyled>{t('Password')}:*</LoginPageLabelStyled>
                        <LoginPageInputStyled
                            ref={passRef}
                            type="password"
                            required={true}
                            onKeyDown={(e) => { try { if (isPureEnter(e)) onSignInClick(); } catch(ex) {} } }
                            onKeyUp={(e) => { try { formData.password = e.target.value } catch(ex) {} } }
                        />
                        <LoginPageButtonStyled
                            onClick={onSignInClick}
                        >Sign in</LoginPageButtonStyled>
                    </LoginPageModalBoxStyled>
                </LoginPageStyled>

            </LoginContentStyled>
            {
                loginResult.show &&
                <Toast
                    animation={{
                        show:{ type: 'fade', duration: 200, from: 0, to: 1 },
                        hide:{ type: 'fade', duration: 600, from: 1, to: 0 },
                    }}
                    visible={loginResult.show}
                    message={loginResult.message}
                    displayTime={2500}
                    type={'error'}
                    position={{ my:'bottom center', at:'bottom center', of:'window', offset:{ x:0, y:-64 } }}
                    onHidden={onLoginResultToastHidden}
                    maxWidth={'480px'}
                />
            }
        </>
    );
}


LoginForm.propTypes = {
    builder:PropTypes.bool.isRequired,
};


LoginForm.defaultProps = {
    builder:false,
};


export default LoginForm;